import init from './init';
import themeEditor from './themeEditor';

export default () => {
  init();
  themeEditor();
};
